<template>
    <b-dropdown text="Más opciones" class="mx-1 border" :variant="'light'">
        <b-dropdown-item v-b-modal="'show_' + booking.id">Ver detalles de la reserva</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item 
            :disabled="(!booking.excursion_service && !booking.pickup_service)"
            @click="setBusService(false, false)"
        >
            Solo ticket
        </b-dropdown-item>
        <b-dropdown-item 
            :disabled="(booking.excursion_service && !booking.pickup_service)"
            @click="setBusService(true, false)"
        >
            Excursión SÍ / Recogida NO
        </b-dropdown-item>
        <b-dropdown-item 
            :disabled="(!booking.excursion_service && booking.pickup_service)"
            @click="setBusService(false, true)"
        >
            Excursión NO / Recogida SÍ
        </b-dropdown-item>
        <b-dropdown-item 
            :disabled="(booking.excursion_service && booking.pickup_service)"
            @click="setBusService(true, true)"
        >
            Excursión SÍ / Recogida SÍ
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item>
          <div @click="archive(booking.id)">
            <i class="fa fa-archive fa-fw"></i> Archivar reserva
          </div>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
/* eslint-disable */
export default {
    props: {
        booking: {
            type: Object,
            required: true
        }
    },
    methods: {
        async setBusService(excursion, pickup) {
            const payload = {
                id: this.booking.id,
                data: {
                service_excursion: excursion,
                service_pickup : pickup
                }
            }
            await this.$store.dispatch("bookings/modifyBusService", payload)
                .then( response => {
                this.$notify({
                    group: "foo",
                    title: "Reserva modificada",
                    text: `Servicios de bus modificados`,
                    type: "success",
                });
                })
                .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "Reserva no se ha podido modificar",
                    text: `No se ha podido modificar la reserva`,
                    type: "error",
                });
                })
        },
        async archive(bookingId) {
          const payload = {
            id: bookingId
          }
          await this.$store.dispatch("bookings/archive", payload)
        }
    }
}
</script>